export default __webpack_public_path__ + "assets/logout-white.17c7.svg";